import React from 'react';

import { SelectInput } from 'hosman-material';

const financingStateOptions = [
  { id: 1, value: 'agreement', name: 'Budget validé avec une banque / un courtier' },
  { id: 2, value: 'ongoing', name: 'En cours de discussion avec une banque / un courtier' },
  { id: 3, value: 'not_yet', name: 'Pas encore défini' },
  { id: 4, value: 'cash_payment', name: 'Paiement comptant' }
];

const FinancingStateSelect = ({ buyerAlert, setStateBuyerAlert, errors }) => {
  return (
    <div className='min-w-[280px]'>
      <SelectInput
        name='financing_state'
        options={financingStateOptions}
        selectedOption={financingStateOptions.find(option => option.value === buyerAlert.financing_state) || null}
        handleChange={(e) => setStateBuyerAlert({ ...buyerAlert, financing_state: e.value })}
        label='Où en êtes-vous dans votre projet de financement ?'
        errors={errors}
      />
    </div>
  )
}

export default FinancingStateSelect;
